/* 🤖 this file was generated by script */
export const wiconLock04 = {
  name: 'lock_04',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7.1 10H7V8a5 5 0 0110 0v2h-.1M12 14v2m7-1a7 7 0 11-14 0 7 7 0 0114 0z"/></svg>`,
};
